import { Percentage } from '@sparkdotfi/common-universal'

import type { AaveData, AaveUserReserve } from './aave-data-layer/query'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export interface IncentivesData {
  deposit: Incentive[]
  borrow: Incentive[]
}

export interface Incentive {
  token: Token
  APR: Percentage
}

type ReserveIncentiveResponse = NonNullable<AaveData['formattedReserves'][number]['aIncentivesData']>[number]
export function getIncentivesData(
  reserve: AaveUserReserve,
  findOneBySymbol: (symbol: TokenSymbol) => Token,
): IncentivesData {
  function formatIncentive(incentive: ReserveIncentiveResponse): Incentive {
    const token = findOneBySymbol(TokenSymbol(incentive.rewardTokenSymbol))

    return {
      token,
      APR: Percentage(incentive.incentiveAPR),
    }
  }

  return {
    deposit: (reserve.aIncentivesData ?? []).map(formatIncentive).filter(notZeroIncentive),
    // Spark doesn't support stable borrows, so it's safe to assume that the only incentive for borrow is the variable borrow
    borrow: (reserve.vIncentivesData ?? []).map(formatIncentive).filter(notZeroIncentive),
  }
}

function notZeroIncentive(incentive: Incentive): boolean {
  return !incentive.APR.isZero()
}
